/**
 * Renders one of System Card's `RichHtml` strings (inline links, strong, em
 * and friends) the way guide bodies render trusted HTML.
 *
 * No "use client": this is a plain server-safe leaf with no hooks and no
 * interactivity, so it stays renderable from a server component and does not
 * force a client boundary onto whatever page embeds it.
 *
 * Not sanitized at render: the only input is `SYSTEM_CARD_EDITIONS`, a reviewed
 * repo constant. If anything user-supplied ever reaches this component, that
 * invariant breaks and it needs a real sanitizer. Trust argument and the
 * test-time guard: `src/lib/learn/trustedHtmlAllowlist.ts`.
 */
export interface TrustedInlineHtmlProps {
  html: string;
  className?: string;
  /** Defaults to "span"; pass "p" or "div" where block-level is wanted. */
  as?: "span" | "p" | "div";
}

export function TrustedInlineHtml({ html, className, as: Tag = "span" }: TrustedInlineHtmlProps) {
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
